import axios from '../services/request'
/* 学生班级列表 */
export const Plan = (data = {}) => axios.get('api/student/plan',data);

/* 班级码搜索班级 */
export const searchPlan = (data = {}) => axios.get('api/student/getPlan',data);

/* 加入班级 */
export const pushPlan = (data = {}) => axios.get('api/student/pushPlan',data);

/* 班级班级详情 */
export const planDetail = (data = {}) => axios.get('api/student/planDetail',data);

/* 退出班级 */
export const quitPlan = (data = {}) => axios.get('api/student/quitPlan',data);

/* 班级作业 */
export const Task = (data = {}) => axios.get('api/studentwork/task',data);

/* 作业详情 */
export const workDetail = (data = {}) => axios.get('api/studentwork/workDetail',data);

/* 成绩统计 */
export const workResult = (data = {}) => axios.get('api/studentwork/workResult',data);

/* 历史记录 */
export const historyList = (data = {}) => axios.get('api/studentwork/historyList',data);

/* 分层教学 */
export const getStage = (data = {}) => axios.get('api/studentwork/getStage',data);

/* 分层教学做题记录 */
export const getStageSubmit = (data = {}) => axios.get('api/studentwork/getStageSubmit',data);

/* 分层教学题目 */
export const stageWork = (data = {}) => axios.get('api/studentwork/stageWork',data);

/* 学习计划列表 */
export const mapList = (data = {}) => axios.get('api/mapout/index',data);

/* 创建学习计划 */
export const mapCreate = (data = {}) => axios.post('api/mapout/create',data);

/* 学习计划详情 */
export const mapDetail = (data = {}) => axios.get('api/mapout/detail',data);

/* 消息列表 */
export const tidingsList = (data = {}) => axios.get('api/student/tidingsList',data);

/* 阅读详情作业列表 */
export const readDetailWork = (data = {}) => axios.get('api/studentwork/readDetailWork',data);

/* 验证作业是否可做 */
export const doWork = (data = {}) => axios.get('api/studentwork/doWork',data);


/* 作业管理首页顶部统计 */
export const workIndexStatistics = (data = {}) => axios.get('api/studentwork/workIndexStatistics',data);

/* 作业管理首页作业列表 */
export const workList = (data = {}) => axios.get('api/studentwork/workList',data);


/* 作业详情顶部统计 */
export const workDetailTopStatistics = (data = {}) => axios.get('api/studentwork/workDetailTopStatistics',data);


/* 作业详情周期列表 */
export const workDetailPeriods = (data = {}) => axios.get('api/studentwork/workDetailPeriods',data);


/* 作业详情周期作业列表 */
export const workDetailWorkList = (data = {}) => axios.get('api/studentwork/workDetailWorkList',data);


/* 自主学习记录 */
export const studySelfList = (data = {}) => axios.get('api/studentwork/studySelfList',data);

/* 分层教学详情顶部统计 */
export const stageDetailTopStatistics = (data = {}) => axios.get('api/studentwork/stageDetailTopStatistics',data);


/* 自主学习统计 */
export const studySelfStatistics = (data = {}) => axios.get('api/studentwork/studySelfStatistics',data);


/* 获取分层教学题目 */
export const getStageWork = (data = {}) => axios.get('api/studentwork/getStageWork',data);

export default{
    Plan,
    getStageWork,
    studySelfStatistics,
    stageDetailTopStatistics,
    workDetailWorkList,
    studySelfList,
    workDetailTopStatistics,
    workDetailPeriods,
    workList,
    searchPlan,
    pushPlan,
    planDetail,
    quitPlan,
    Task,
    workDetail,
    workResult,
    historyList,
    getStage,
    getStageSubmit,
    stageWork,
    mapList,
    mapCreate,
    mapDetail,
    tidingsList,
    readDetailWork,
    doWork,
    workIndexStatistics
}